import { getActivityFeedStore, getActivityFeedAccountStore } from './store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { isAccountInActivityFeedStore } from '../utils/isAccountInActivityFeedStore';
import selectAccountNotificationStore from './selectAccountNotificationStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import { areNotificationsEnabledForAccount } from '../utils/areNotificationsEnabledForAccount';
import areNotificationsEnabled from 'owa-notifications-settings/lib/selectors/areNotificationsEnabled';

export const getUnseenItemsCount = (): number => {
    let count = 0;
    const store = getActivityFeedStore();
    if (!store.isOpx && (store.isActivityFeedOpen || !areNotificationsEnabled())) {
        return count;
    }

    if (isFeatureEnabled('notif-filterByAccount')) {
        const selectedAccountOptions = selectAccountNotificationStore().selectedAccountOptions;
        if (selectedAccountOptions.size > 0) {
            return Array.from(selectedAccountOptions).reduce(
                (total, mailboxInfo) => total + getUnseenItemsCountForMailbox(mailboxInfo),
                count
            );
        }
    } else if (store.accountItems.size > 0) {
        const mailboxInfo = getModuleContextMailboxInfo();
        count = getUnseenItemsCountForMailbox(mailboxInfo);
    }
    return count;
};

export const getUnseenItemsCountForMailbox = (mailboxInfo: MailboxInfo): number => {
    let count = 0;
    if (!areNotificationsEnabledForAccount(mailboxInfo)) {
        return count;
    }

    // Check if the account has been added to the store since it's possible that OwaSuiteHeader calls
    // this function before a newly added account is initialized in the notifications store.
    if (isAccountInActivityFeedStore(mailboxInfo)) {
        const { items } = getActivityFeedAccountStore(mailboxInfo);
        const unseenItems = [...items.values()].filter(item => !item.isSeen);
        count = unseenItems.length;
    }
    return count;
};
